/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './verification.defs.js'
export * as $defs from './verification.defs.js'
